exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AutoInsuletWebLink{margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:200px;width:288px}.AutoInsuletWebLink-image{width:50px;height:50px}", ""]);

// exports
